module.exports = __webpack_public_path__ + "static/img/realTimeImg.b331227.png";